import { createContext } from "react";
import { EditProductContextProps } from "./EditProductContextProvider";



export const EditProductContext = createContext<
  EditProductContextProps | undefined
>(undefined);
